<template>
    <q-card>
        <q-form @submit.prevent="updateCaption">
            <q-card-section>
                <div class="text-h6">Редактировать подписи к фото</div>
            </q-card-section>


            <q-card-section class="q-pt-none">
                <q-input dense v-model="caption" type="textarea" label="Подпись" />
            </q-card-section>

            <q-card-actions align="right" class="text-primary">
                <q-btn no-caps flat label="Обновить" type="submit" />
            </q-card-actions>
        </q-form>
    </q-card>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useRouteParams } from '@vueuse/router'
import { useProjectPhotoCaption, useUpdateProjectPhotoCaption } from "../composables/project";

const caption = ref<string | null>(null);

const projectId = useRouteParams('projectId', undefined, { transform: Number })

const { data, execute: fetchCaption } = useProjectPhotoCaption(projectId.value);
const { execute } = useUpdateProjectPhotoCaption(projectId.value, caption);

watch(data, (val) => {
    caption.value = val?.caption ?? null
})

async function updateCaption() {
    await execute()
    await fetchCaption()
}
</script>

<style scoped></style>